<template>
	<div class="h100 analyze_right">
		<div class="title">
			<el-form ref="addForm"
					 class="ef-form"
					 :model="addForm"
					 :rules="addRules"
					 label-width="80px">
				<el-row class="mt5">
					<el-col :span="15"
							class="el-left">
						<template v-if="macthPrice !== '2'">
							<el-radio-group v-model="radio2"
											@change="clickRadio">
								<el-radio :label="1">价格</el-radio>
								<el-radio :label="2">涨跌幅</el-radio>
							</el-radio-group>
						</template>
						<template v-else>
							<el-radio-group v-model="radio2"
											@change="clickMacthPrice">
								<el-radio :label="1">价格</el-radio>
								<el-radio :label="2">涨跌幅</el-radio>
							</el-radio-group>
						</template>
					</el-col>
					<el-col :span="9"
							class="el-col-flex">
						<el-form ref="addForm"
								 class="inner-form"
								 label-width="80px">
							<el-row>
								<el-col :span="10"
										v-show="currentRadio === 2 && macthPrice !== '2'">
									<el-form-item label="基数"
												  prop="baseMonth">
										<el-date-picker v-model="addForm.baseMonth"
														@change="timeChange($event,currentRadio)"
														type="month"
														value-format="yyyy-MM"
														placeholder="所属月份">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="10"
										v-show="currentRadio === 1 && macthPrice !== '2' || currentRadio === 2 && macthPrice !== '2'">
									<el-form-item label="当期"
												  prop="yearAndMonth">
										<el-date-picker v-model="addForm.yearAndMonth"
														@change="timeChange($event,currentRadio)"
														type="month"
														value-format="yyyy-MM"
														placeholder="所属月份">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="20"
										v-show="currentRadio === 1 && macthPrice === '2' || currentRadio === 2 && macthPrice === '2'">
									<el-form-item label="时间区间"
												  prop="busImpList">
										<el-date-picker v-model="addForm.busImpList"
														@change="timeChange($event,currentRadio)"
														align="right"
														type="monthrange"
														format="yyyy 年 MM"
														value-format="yyyy-MM"
														unlink-panels
														range-separator="至"
														start-placeholder="开始日期"
														end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="4"
										class="margin">
									<el-button type="primary"
											   size="small"
											   @click="exportChange">导出图片</el-button>
								</el-col>
							</el-row>
						</el-form>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<template v-if="macthPrice === '1'">
			<div v-show="currentRadio === 1"
				 class="content-echart"
				 id="Comparison">
			</div>

			<div v-show="currentRadio === 2"
				 class="content-echart"
				 id="RegionRadioOne">
			</div>
		</template>

		<template v-else>
			<div v-show="currentRadio === 1"
				 class="content-echart"
				 id="TrendComparison">
			</div>

			<div v-show="currentRadio === 2"
				 class="content-echart"
				 id="Trend">
			</div>
		</template>

		<!-- 弹窗点击下载图片 -->
		<el-dialog :title="dialogModel.title"
				   :visible.sync="dialogModel.visible"
				   :width="dialogModel.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<div class="text-center h100 overflow-hidden"
				 style="width:100%;height:500px"
				 id="enlarge_echart">
			</div>
			<!-- 底部按钮 -->
			<div slot="footer"
				 v-if="dialogModel.type === 'add'"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">下载图片</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	priceComparison,
	rangeComparison,
	priceTrendComparison,
	rangeTrendComparison
} from '@/api/modules/analyze_tab'
import { dateFormat } from '@/utils/tools.js'
export default {
	name: 'Interregional_analysis_right',
	props: {
		//当前地区
		activeName: {
			type: String,
			default: ''
		},
		//当前地区名
		cityName:{
			type:String,
			default:''
		},
		//信息市场价
		priceType: {
			type: Number,
			default: null
		},
		//工种编码
		codesList: {
			type: Array,
			default: {}
		},
		//城市
		CitysList: {
			type: Array,
			default: {}
		},
		//地区间传递的工种编码
		/*
		macthCode: {
			type: String,
			default: ''
		},
		*/
		macthCode: {
            type: Object,
            default: () => {
                return {}
            }
        },
		//价格走势对比
		macthPrice: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			radio: 1,
			radio2: 1,
			currentRadio: 1,
			addForm: {
				busImpList: [], // 起止日期数组
				yearAndMonth: '', //当期
				baseMonth: '', //基数
				startTime: '',
				endTime: ''
			},
			// 弹窗对象
			dialogModel: {
				title: '预览图表',
				visible: false,
				width: '80%',
				type: 'add'
			},
			btnLoading: false,
			addRules: {},
			codeSname: [],
			codePrice: [],
			priceList: [],
			snameList: [],
			legendname: [],
			cityList: [],
			priceData: []
		}
	},
	created() {},
	mounted() {
		//获取当前价格初始化数据
		this.$nextTick(() => {
		})
	},
	methods: {
		//时间事件
		timeChange(e, index) {
			let start = e[0],
				end = e[1]
			if (this.macthPrice === '1') {
				switch (index) {
					case 1:
						this.addForm.yearAndMonth = e
						if (this.codesList) {
							this.initChart()
						}
						break
					case 2:
						if (
							this.addForm.baseMonth >= this.addForm.yearAndMonth
						) {
							this.$message.warning('基数时间不能大于当期时间')
							return
						}
						this.getRegion()
						break
				}
			} else {
				switch (index) {
					case 1:
						this.addForm.startTime = start
						this.addForm.endTime = end
						if (this.codesList) {
							this.getTrendComparison()
						}
						break
					case 2:
						this.addForm.startTime = start
						this.addForm.endTime = end
						this.getTrend()
						break
				}
			}
		},

		//radio点击事件 价格对比1
		clickRadio(val) {
			this.$emit('on-radio-change',val)
			let that = this
			that.currentRadio = val
			that.addForm.busImpList = []
			switch (val) {
				case 1:
					let month = dateFormat().substring(0, 7)
					that.addForm.yearAndMonth = month
					setTimeout(() => {
						that.initChart()
					}, 200)
					break
				case 2:
					let lastYear = new Date().getFullYear(),
						lastmonth = Math.floor((new Date().getMonth() + 3) / 3)
					if (lastmonth < 10) {
						lastmonth = '0' + lastmonth
					}
					this.addForm.baseMonth = lastYear + '-' + lastmonth
					setTimeout(() => {
						this.getRegion()
					}, 100)
					break
			}
		},

		//radio点击事件 走势对比2
		clickMacthPrice(val) {
			this.$emit('on-radio-change', val)
			let that = this
			that.currentRadio = val
			that.addForm.busImpList = []
			switch (val) {
				case 1:
					let fullYear = new Date().getFullYear(),
						fullStartmonth = new Date().getMonth() - 4,
						fullEedmonth = new Date().getMonth() + 5,
						fullStarttimes = [],
						fullEedtimes = []
					if (fullStartmonth < 10) {
						fullStartmonth = '0' + fullStartmonth
					}
					if (fullEedmonth < 10) {
						fullEedmonth = '0' + fullEedmonth
					}

					fullStarttimes.push(fullYear, fullStartmonth)
					fullEedtimes.push(fullYear, fullEedmonth)
					that.addForm.startTime = fullStarttimes.join('-')
					that.addForm.endTime = fullEedtimes.join('-')
					that.addForm.busImpList.push(
						that.addForm.startTime,
						that.addForm.endTime
					)
					setTimeout(() => {
						that.getTrendComparison()
					}, 100)
					break
				case 2:
					let fullYear1 = new Date().getFullYear(),
						fullStartmonth1 = new Date().getMonth() - 4,
						fullEedmonth1 = new Date().getMonth() + 5,
						fullStarttimes1 = [],
						fullEedtimes1 = []
					if (fullStartmonth1 < 10) {
						fullStartmonth1 = '0' + fullStartmonth1
					}
					if (fullEedmonth1 < 10) {
						fullEedmonth1 = '0' + fullEedmonth1
					}

					fullStarttimes1.push(fullYear1, fullStartmonth1)
					fullEedtimes1.push(fullYear1, fullEedmonth1)
					that.addForm.startTime = fullStarttimes1.join('-')
					that.addForm.endTime = fullEedtimes1.join('-')
					that.addForm.busImpList.push(
						that.addForm.startTime,
						that.addForm.endTime
					)
					setTimeout(() => {
						that.getTrend()
					}, 100)
					break
				default:
			}
		},

		//导出图片事件
		exportChange() {
			let that = this
			that.dialogModel.visible = true
			that.dialogModel.type = 'add'
			if (that.macthPrice === '1') {
				switch (that.currentRadio) {
					case 1:
						setTimeout(() => {
							that.initChart('111')
						}, 300)
						break
					case 2:
						setTimeout(() => {
							that.getRegion('111')
						}, 300)
						break
					default:
				}
			} else {
				switch (that.currentRadio) {
					case 1:
						setTimeout(() => {
							that.getTrendComparison('111')
						}, 300)
						break
					case 2:
						setTimeout(() => {
							that.getTrend('111')
						}, 300)
						break
					default:
				}
			}
		},

		//获取当前价格
		initChart(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('Comparison')
			let Comparison = this.$echarts.init(dom),
				option = {},
				RadioName = this.radio2 === 1 ? '价格' : '涨跌幅',
				that = this
			Comparison.showLoading()
			priceComparison({
				citys: this.CitysList,
				currentPeriod: this.addForm.yearAndMonth,
				codes: this.codesList,
				priceType: this.priceType
			})
				.then(res => {
					if (res.code === 0) {
						Comparison.hideLoading()
						this.codeSname = res.data.cityList.map(v => {
							return v
						})
						that.codePrice = []
						res.data.rangeList.forEach(item => {
							that.codePrice.push({
								name: item.name,
								type: 'bar',
								barGap: 0,
								data: item.data
							})
						})
						that.legendname = that.codePrice.map(v => {
							return v.name
						})
					} else {
						this.$message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							color: [
								'#c8bd7e',
								'#88b4ca',
								'#d18061',
								'#65c5bd',
								'#65c57e',
								'#1193cf',
								'#ca88c8',
								'#b38661',
								'#4fcce7',
								'#d16361',
								'#7173c3',
								'#bdc751',
								'#e0a361',
								'#548369',
								'#ca888e',
								'#9fb361',
								'#c8bd7e',
								'#88b4ca'
							],
							title: {
								text:val?this.textTitle = 
									this.addForm.yearAndMonth +
									'' +
									this.cityName +
									'工种' +
									RadioName:'',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位(元)',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
                                            '</br>' +
                                           
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								}
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							legend: {
								data: that.legendname,
								left: '10%',
								top:val?'5%':10,
								type: 'scroll'
							},
							xAxis: [
								{
									type: 'category',
									data: this.codeSname,
									axisTick: {
										alignWithLabel: true
									},
									axisLabel: {
										interval: 0, //强制文字产生间隔
										rotate: 45, //文字逆时针旋转45°
										textStyle: {
											//文字样式
											fontSize: 14,
											fontFamily: 'Microsoft YaHei'
										}
									}
								}
							],
							yAxis: [
								{
									type: 'value'
								}
							],
							series: that.codePrice
						}
						Comparison.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							Comparison.setOption(option, true)
							window.addEventListener('resize', () => {
								Comparison.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//涨跌幅
		getRegion(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('RegionRadioOne')
			let RegionRadioOne = this.$echarts.init(dom),
				option = {},
				RadioName = this.radio2 === 1 ? '价格' : '涨跌幅',
				that = this
			RegionRadioOne.showLoading()
			rangeComparison({
				citys: this.CitysList,
				currentPeriod: this.addForm.yearAndMonth,
				codes: this.codesList,
				priceType: this.priceType,
				basePeriod: this.addForm.baseMonth
			})
				.then(res => {
					if (res.code === 0) {
						RegionRadioOne.hideLoading()
						this.snameList = res.data.cityList.map(v => {
							return v
						})
						that.priceList = []
						res.data.rangeList.forEach(item => {
							that.priceList.push({
								name: item.name,
								type: 'bar',
								barGap: 0,
								data: item.data
							})
						})
						that.legendname = that.priceList.map(v => {
							return v.name
						})
					} else {
						this.$Message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							color: [
								'#c8bd7e',
								'#88b4ca',
								'#d18061',
								'#65c5bd',
								'#65c57e',
								'#1193cf',
								'#ca88c8',
								'#b38661',
								'#4fcce7',
								'#d16361',
								'#7173c3',
								'#bdc751',
								'#e0a361',
								'#548369',
								'#ca888e',
								'#9fb361',
								'#c8bd7e',
								'#88b4ca'
							],
							title: {
								text:val?this.textTitle = this.addForm.baseMonth +
									'~' +
									this.addForm.yearAndMonth +
									'' +
									this.cityName +
									'工种' +
									RadioName:'',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位(%)',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
                                            '</br>' +
                                           
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								}
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							legend: {
								data: that.legendname,
								left: '10%',
								top:val?'5%':10,
								type: 'scroll'
							},
							xAxis: [
								{
									type: 'category',
									data: this.snameList,
									axisTick: {
										alignWithLabel: true
									},
									axisLabel: {
										interval: 0, //强制文字产生间隔
										rotate: 45, //文字逆时针旋转45°
										textStyle: {
											//文字样式
											fontSize: 14,
											fontFamily: 'Microsoft YaHei'
										}
									}
								}
							],
							yAxis: [
								{
									type: 'value'
								}
							],
							series: that.priceList
						}
						RegionRadioOne.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							RegionRadioOne.setOption(option, true)
							window.addEventListener('resize', () => {
								RegionRadioOne.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//走势对比价格
		getTrendComparison(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('TrendComparison')
			let TrendComparison = this.$echarts.init(dom),
				option = {},
				RadioName = this.radio2 === 1 ? '价格' : '涨跌幅',
				that = this,
				color = [
					'#c8bd7e',
					'#88b4ca',
					'#d18061',
					'#65c5bd',
					'#65c57e',
					'#1193cf',
					'#ca88c8',
					'#b38661',
					'#4fcce7',
					'#d16361',
					'#7173c3',
					'#bdc751',
					'#e0a361',
					'#548369',
					'#ca888e',
					'#9fb361',
					'#c8bd7e',
					'#88b4ca'
				]
			TrendComparison.showLoading()
			priceTrendComparison({
				citys: this.CitysList,
				basePeriod: this.addForm.startTime,
				code: this.macthCode,
				priceType: this.priceType,
				currentPeriod: this.addForm.endTime
			})
				.then(res => {
					if (res.code === 0) {
						TrendComparison.hideLoading()
						that.cityList = res.data.yearMonths
						that.snameList = res.data.priceList.map(v => {
							return v.name
						})
						that.priceData = []
						res.data.priceList.forEach(item => {
							that.priceData.push({
								name: item.name,
								type: 'line',
								barGap: 0,
								data: item.data,
								color: item.color
							})
						})
					} else {
						this.$message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							title: {
								text:val?this.textTitle = this.addForm.startTime +
									'~' +
									this.addForm.endTime +
									'' +
									this.cityName +
									'工种' +
									RadioName:'',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位（元）',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								},
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
                                            '</br>' +
                                           
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								}
							},
							legend: {
								borderColor: color,
								data: that.snameList,
								left: '10%',
								top:val?'5%':10,
								type: 'scroll'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: that.cityList
							},
							yAxis: {
								type: 'value'
							},
							series: that.priceData
						}
						TrendComparison.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							TrendComparison.setOption(option, true)
							window.addEventListener('resize', () => {
								TrendComparison.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		//走势对比涨幅
		getTrend(val) {
			var dom = val
				? document.getElementById('enlarge_echart')
				: document.getElementById('Trend')
			let Trend = this.$echarts.init(dom),
				option = {},
				RadioName = this.radio2 === 1 ? '价格' : '涨跌幅',
				that = this
			Trend.showLoading()
			rangeTrendComparison({
				citys: this.CitysList,
				basePeriod: this.addForm.startTime,
				code: this.macthCode,
				priceType: this.priceType,
				currentPeriod: this.addForm.endTime
			})
				.then(res => {
					if (res.code === 0) {
						Trend.hideLoading()
						that.yearMonth = res.data.yearmonths
						that.snameList = res.data.rangeList.map(v => {
							return v.name
						})
						that.priceData = []
						res.data.rangeList.forEach(item => {
							that.priceData.push({
								name: item.name,
								type: 'line',
								barGap: 0,
								data: item.data
							})
						})
					} else {
						this.$message.error('获取信息出错，请联系管理员!')
					}
					this.$nextTick(() => {
						// 指定图表的配置项和数据
						option = {
							title: {
								text:val?this.textTitle = this.addForm.startTime +
									'~' +
									this.addForm.endTime +
									'' +
									this.cityName +
									'工种' +
									RadioName:'',
								top: '0%',
								left: '2%',
								textStyle: {
									color: '#031f2d',
									fontSize: 16,
									align: 'center'
								},
								subtext: '单位（元）',
								subtextStyle: {
									color: '#031f2d',
									fontSize: 14,
									align: 'left'
								}
							},
							tooltip: {
								trigger: 'axis',
								formatter: function(params) {
									let str = params[0].axisValue
									params.map((x, index) => {
										str +=
                                            '</br>' +
                                           
											x.marker +
											' ' +
											x.seriesName +
											' : ' +
											x.value +
											' 元'
									})
									return str
								},
								textStyle: {
									align: 'left'
								},
								axisPointer: {
									// 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							legend: {
								data: that.snameList,
								left: '10%',
								top:val?'5%':10,
								type: 'scroll'
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: that.yearMonth
							},
							yAxis: {
								type: 'value'
							},
							series: that.priceData
						}
						Trend.resize()
						if (
							option &&
							typeof option === 'object' &&
							!this.isEmpatyData
						) {
							Trend.setOption(option, true)
							window.addEventListener('resize', () => {
								Trend.resize()
							})
						}
					})
				})
				.catch(err => {})
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogModel.visible = false
		},

		//确定事件
		doConfirm() {
			let echartLarge = this.$echarts.init(
				document.getElementById('enlarge_echart')
			)
			this.$emit('on-Download-pictures', echartLarge,this.textTitle)
		},
	},
	computed: {},
	watch: {
		cityName: {
			handler(val) {
				this.cityName = val
			},
			deep: true
		},
		codesList: {
			handler(val) {
				this.codesList = val
			},
			deep: true
		},
		activeName: {
			handler(val) {
				this.activeName = val
			},
			deep: true
		},
		priceType: {
			handler(val) {
				this.priceType = val
				switch (this.currentRadio) {
					case 1:
						if (
							this.currentRadio === 1 &&
							this.macthPrice === '1'
						) {
							setTimeout(() => {
								this.initChart()
							}, 300)
						} else {
							setTimeout(() => {
								this.getTrendComparison()
							}, 300)
						}

						break
					case 2:
						if (
							this.currentRadio === 1 &&
							this.macthPrice === '1'
						) {
							setTimeout(() => {
								this.getRegion()
							}, 300)
						} else {
							setTimeout(() => {
								this.getTrend()
							}, 300)
						}
						break
					default:
				}
			},
			deep: true
		},
		macthCode: {
			handler(val) {
				this.macthCode = val
			},
			deep: true
		},
		macthPrice: {
			handler(val) {
				this.macthPrice = val
			},
			deep: true
		}
	}
}
</script>
<style scoped lang="less">
.analyze_right {
	.title {
		display: flex;
		flex-flow: column;
		width: 100%;
		padding: 0 0 0 20px;
		box-sizing: border-box;
		.ef-form {
			width: 100%;
			.el-row {
				width: 100%;
				display: flex;
				-webkit-box-pack: end;
				-ms-flex-pack: end;
				justify-content: flex-end;
			}
		}
		.el-col-flex {
			flex: 1;
		}
	}
	.ishow {
		width: 100%;
		height: 32px;
		line-height: 32px;
		text-align: center;
	}
	.content-echart {
		height: calc(100% - 37px);
		width: 100%;
	}
	.price-echart {
		height: calc(100% - 69px);
		width: 100%;
	}
	.el-right {
		flex: 1;
		text-align: right;
	}
}
</style>